<template>
  <div>
    <TopHeader class="bg-color-wrap" />
    <MainNavbar />
    <PageBanner pageTitle="Case Study Details" />
    <CaseStudyDetails />
    <OverView />
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layout/TopHeader";
import MainNavbar from "../Layout/MainNavbar";
import PageBanner from "../Common/PageBanner";
import CaseStudyDetails from "../CaseStudyDetails/CaseStudyDetails";
import OverView from "../Common/OverView";
import MainFooter from "../Layout/MainFooter";

export default {
  name: "CaseStudyDetailsPage",
  components: {
    TopHeader,
    MainNavbar,
    PageBanner,
    CaseStudyDetails,
    OverView,
    MainFooter,
  },
};
</script>